import { render, staticRenderFns } from "./FooterColumn.vue?vue&type=template&id=3c4d3e5c&scoped=true&"
import script from "./FooterColumn.vue?vue&type=script&lang=ts&"
export * from "./FooterColumn.vue?vue&type=script&lang=ts&"
import style0 from "./FooterColumn.vue?vue&type=style&index=0&id=3c4d3e5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4d3e5c",
  null
  
)

export default component.exports